import { Prettify } from '@frontend/types';
import { ButtonProps } from '@frontend/design-system';
import { GatewaySwitch } from '../../../components/switches/gateway-switch';
import { CardOnFileProps } from '../../card-on-file';
import { CardOnFileJustifiProvider } from './card-on-file-justifi.context';
import { CardOnFileStripeProvider } from './card-on-file-stripe.context';

export type CardOnFileBaseContext = {
  onSubmit: () => Promise<void>;
  primary: ButtonProps;
  secondary: ButtonProps;
  shouldShowFooter: boolean;
  shouldShowLoading: boolean;
};

export type CardOnFileProviderProps = Prettify<Omit<CardOnFileProps, 'locationId' | 'merchant'>>;

export const CardOnFileProvider = ({ children, ...props }: CardOnFileProviderProps) => {
  return (
    <GatewaySwitch
      stripeProps={props}
      stripeContent={CardOnFileStripeProvider}
      justifiProps={props}
      justifiContent={CardOnFileJustifiProvider}
    >
      {children}
    </GatewaySwitch>
  );
};
